import { Validator } from 'fluentvalidation-ts';
import { beBetweenInclusive, haveDecimalPlaces } from '../../../../../validators/stringValidators';
import { DownlossTypeCode } from '../../rooms/heatLoss/downlossTypeCode';
import { defaultGroundBelowTemperatureInDegreesCelsius } from '../../rooms/heatLoss/roomHeatLossDefaults';
import { getDistinctFloorLevelCodes, UnitFormModel } from '../unitFormModel';

export type UnitFloorElementFormModel = {
  floorElementId: number | null;
  name: string;
  floorThermalTransmittance: string;
  downlossTypeCode: DownlossTypeCode;
  defaultTemperatureBelowInDegreesCelsius: string;
};

export const getDefaultUnitFloorElementFormModels = (unit: UnitFormModel): Array<UnitFloorElementFormModel> => {
  const distinctFloorLevelCodes = getDistinctFloorLevelCodes(unit);

  if (distinctFloorLevelCodes.length > 1) {
    return [
      {
        ...getDefaultUnitFloorElementFormModel(),
        name: 'Ground Element 1',
      },
      {
        ...getDefaultUnitFloorElementFormModel(),
        name: 'Upper Element 1',
        downlossTypeCode: 'RoomBelow',
        defaultTemperatureBelowInDegreesCelsius: '16',
      },
    ];
  } else {
    return [{ ...getDefaultUnitFloorElementFormModel(), name: 'Floor Element 1' }];
  }
};

export const getDefaultUnitFloorElementFormModel = (): UnitFloorElementFormModel => ({
  floorElementId: null,
  name: 'Floor Element 1',
  floorThermalTransmittance: '',
  downlossTypeCode: 'GroundBelow',
  defaultTemperatureBelowInDegreesCelsius: defaultGroundBelowTemperatureInDegreesCelsius.toString(),
});

export class UnitFloorElementFormModelValidator extends Validator<UnitFloorElementFormModel> {
  constructor(heatLossIsRequired: boolean) {
    super();

    this.ruleFor('name')
      .notEmpty()
      .maxLength(100);

    this.ruleFor('floorThermalTransmittance')
      .must(beBetweenInclusive(0, 99999999))
      .must(haveDecimalPlaces(3));

    this.ruleFor('downlossTypeCode').notEmpty();

    this.ruleFor('floorThermalTransmittance')
      .notEmpty()
      .when(() => heatLossIsRequired);

    this.ruleFor('defaultTemperatureBelowInDegreesCelsius').must(haveDecimalPlaces(1));

    this.ruleFor('defaultTemperatureBelowInDegreesCelsius')
      .notEmpty()
      .when(() => heatLossIsRequired);
  }
}
